/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For 250 mL of a 2% solution: mass = 2% × 250 mL / 100 = 5 g of solute.`)
};

const es_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 250 mL de una solución al 2%: masa = 2% × 250 mL / 100 = 5 g de soluto.`)
};

const de_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für 250 mL einer 2%igen Lösung: Masse = 2% × 250 mL / 100 = 5 g gelöster Stoff.`)
};

const nl_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor 250 mL van een 2% oplossing: massa = 2% × 250 mL / 100 = 5 g opgeloste stof.`)
};

const fr_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour 250 mL d'une solution à 2 % : masse = 2 % × 250 mL / 100 = 5 g de soluté.`)
};

const it_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per 250 mL di una soluzione al 2%: massa = 2% × 250 mL / 100 = 5 g di soluto.`)
};

const pt_br2_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 250 mL de uma solução a 2%: massa = 2% × 250 mL / 100 = 5 g de soluto.`)
};

const pt_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 250 mL de uma solução a 2%: massa = 2% × 250 mL / 100 = 5 g de soluto.`)
};

const ja_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`250 mLの2%溶液の場合: 質量 = 2% × 250 mL / 100 = 溶質5 g。`)
};

const zh_pctsol_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配制 250 mL 2% 溶液：质量 = 2% × 250 mL / 100 = 5 g 溶质。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_ex3", locale)
	if (locale === "en") return en_pctsol_ex3(inputs)
	if (locale === "es") return es_pctsol_ex3(inputs)
	if (locale === "de") return de_pctsol_ex3(inputs)
	if (locale === "nl") return nl_pctsol_ex3(inputs)
	if (locale === "fr") return fr_pctsol_ex3(inputs)
	if (locale === "it") return it_pctsol_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_ex3(inputs)
	if (locale === "pt") return pt_pctsol_ex3(inputs)
	if (locale === "ja") return ja_pctsol_ex3(inputs)
	return zh_pctsol_ex3(inputs)
};